// src/components/WZList.js
import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { AuthContext } from "../context/AuthContext";
import { Dialog } from "primereact/dialog";
import WZForm from "./WZForm";
import printJS from "print-js";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import "../css/WZFormWithPreview.css";
import "../css/WZList.css";
import { addLocale, FilterMatchMode, locale } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { SelectButton } from "primereact/selectbutton";
import { Calendar } from "primereact/calendar";
import pl from "../assets/pl.json";
import { Tag } from "primereact/tag";
import { useMediaQuery } from "react-responsive";
import WZListModal from "./WZListModal";
import { MultiSelect } from "primereact/multiselect";
import { baseURL } from "../utils/api";
import WZPrintTemplate from "./WZPrintTemplate";

function WZList() {
  const options = ["WZ", "RW"];
  const toast = useRef(null);
  const [docType, setDocType] = useState(options[0]);
  const [expandedRows, setExpandedRows] = useState(null);
  const { user, token } = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedWz, setSelectedWz] = useState(null);
  const [visible, setVisible] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    typDokumentu: { value: null, matchMode: FilterMatchMode.CONTAINS },
    numerWZ: { value: null, matchMode: FilterMatchMode.CONTAINS },
    firma: { value: null, matchMode: FilterMatchMode.CONTAINS },
    egz: { value: null, matchMode: FilterMatchMode.CONTAINS },
    odbiorca: { value: null, matchMode: FilterMatchMode.CONTAINS },
    transport: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dataWystawienia: { value: null, matchMode: FilterMatchMode.CONTAINS },
    wydal: { value: null, matchMode: FilterMatchMode.CONTAINS },
    oplacono: { value: null, matchMode: FilterMatchMode.CONTAINS },
    przewoznik: { value: null, matchMode: FilterMatchMode.CONTAINS },
    uwagi: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [firmy, setFirmy] = useState([]);

  // Date range filter — default: 30 days back to today
  const [dateFrom, setDateFrom] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    d.setHours(0, 0, 0, 0);
    return d;
  });
  const [dateTo, setDateTo] = useState(() => {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d;
  });

  const formatDateParam = (d) => {
    if (!d) return undefined;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"]
      ? (_filters["global"].value = value)
      : (_filters["global"] = {
          value: value,
          matchMode: FilterMatchMode.CONTAINS,
        });

    setFilters(_filters);
    setGlobalFilter(value);
  };

  const accept = (id) => {
    deleteDocument(id);
    toast.current.show({
      severity: "info",
      summary: "Potwierdzenie",
      detail: "Usunięto dokument",
      life: 3000,
    });
  };

  const confirm1 = (event, id) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Czy na pewno chcesz usunąć?",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => accept(id),
    });
  };

  const deleteDocument = (docId) => {
    axios
      .delete(`${baseURL}api/wz/${docId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // Po usunięciu usuwamy dokument z lokalnego stanu
        setDocuments((prev) => prev.filter((doc) => doc.id !== docId));
      })
      .catch((error) => {
        console.error("Błąd usuwania dokumentu:", error);
        alert("Nie udało się usunąć dokumentu.");
      });
  };

  const renderPrintableContent = (wzHeader) => {
    return (
      <table
        className="wz-podglad"
        border="1"
        style={{
          width: "100%",
          tableLayout: "fixed",
          borderCollapse: "collapse",
          fontSize: "0.8em",
        }}
      >
        <tbody>
          <tr
            style={{
              border: 0,
              padding: 0,
              //niewidoczny wiersz
            }}
          >
            <td
              style={{
                width: "10%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                width: "20%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                width: "2%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                width: "2%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                width: "10%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
            <td
              style={{
                // width: "15%",
                fontSize: 0,
                margin: 0,
                height: 0,
                padding: 0,
                borderTop: 0,
                overflow: "hidden",
                lineHeight: 0,
              }}
            ></td>
          </tr>
          <tr>
            <td colSpan="2" rowSpan="5" className="wz-podglad-firma">
              {wzHeader.firma ? (
                <div
                  className="firma-opis"
                  style={{
                    fontSize: "0.9em",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <b>{JSON.parse(wzHeader.firma).nazwa}</b>
                  {JSON.parse(wzHeader.firma).kodpocztowy}{" "}
                  {JSON.parse(wzHeader.firma).miasto}{" "}
                  {JSON.parse(wzHeader.firma).ulica}{" "}
                  {JSON.parse(wzHeader.firma).numer}
                  <br />
                  NIP: {JSON.parse(wzHeader.firma).nip} REGON:{" "}
                  {JSON.parse(wzHeader.firma).regon}
                </div>
              ) : (
                ""
              )}
            </td>
            <td colSpan="5" className="wz-podglad-naglowki">
              Odbiorca
            </td>
            <td colSpan="1" rowSpan="5" style={{ width: "10%" }}>
              <b style={{ fontSize: "1.3em" }}>
                {docType === "WZ" ? `WZ` : "RW"}
              </b>
              <br />
              {docType === "WZ" ? `wydanie materiałów` : "pobranie materiałów"}
              <br />
              {docType === "WZ" ? `na zewn.` : "wewn."}
            </td>
            <td colSpan="2" className="wz-podglad-naglowki">
              Nr bieżący {docType === "WZ" ? `WZ` : "RW"}
            </td>
            <td colSpan="2" className="wz-podglad-naglowki">
              Egz.
            </td>
          </tr>
          <tr style={{ height: "25px" }}>
            <td colSpan="5" rowSpan="3" className="adaptive-text">
              <b>
                {wzHeader.odbiorca ? JSON.parse(wzHeader.odbiorca).nazwa : ""}
              </b>
            </td>
            <td colSpan="2" rowSpan="3">
              <b>{wzHeader.numerWZ}</b>
            </td>
            <td colSpan="2" rowSpan="3">
              <b>{wzHeader.egz ? JSON.parse(wzHeader.egz).skrot : ""}</b>
            </td>
          </tr>
          <tr></tr>
          <tr></tr>
          <tr>
            <td colSpan="5" className="wz-podglad-naglowki">
              Przeznaczenie
            </td>
            <td colSpan="4" className="wz-podglad-naglowki">
              Nr i data faktury - specyfikacji
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="wz-podglad-naglowki">
              Środek transportu
            </td>
            <td
              colSpan="5"
              rowSpan="2"
              className="adaptive-text przeznaczenie-cell"
            >
              <b>{wzHeader.przeznaczenie}</b>
            </td>
            <td colSpan="1" className="wz-podglad-naglowki">
              Wysyłka na koszt
            </td>
            <td colSpan="4" rowSpan="2"></td>
          </tr>
          <tr>
            <td colSpan="2" className="adaptive-text">
              <b>
                {wzHeader.transport ? JSON.parse(wzHeader.transport).nrRej : ""}
              </b>
            </td>
            <td></td>
          </tr>
          <tr>
            <td
              rowSpan="2"
              className="wz-podglad-naglowki"
              style={{ width: "10%" }}
            >
              Kod towaru - materiału
            </td>
            <td colSpan="5" rowSpan="2" className="wz-podglad-naglowki">
              Nazwa materiału
            </td>
            <td colSpan="2" className="wz-podglad-naglowki">
              Ilość
            </td>
            <td colSpan="2" className="wz-podglad-naglowki">
              Cena
            </td>
            <td colSpan="2" className="wz-podglad-naglowki">
              Wartość
            </td>
          </tr>
          <tr>
            <td className="wz-podglad-naglowki">Wydana</td>
            <td className="wz-podglad-naglowki">Jedn.</td>
            <td className="wz-podglad-naglowki">zł</td>
            <td className="wz-podglad-naglowki">gr</td>
            <td className="wz-podglad-naglowki">zł</td>
            <td className="wz-podglad-naglowki">gr</td>
          </tr>
          {Array.from({ length: 7 }).map((_, i) => {
            const product = JSON.parse(wzHeader.products)
              ? JSON.parse(wzHeader.products)[i]
              : null;
            return (
              <tr key={i} className="wz-pozycja">
                <td className="adaptive-text" style={{ width: "10%" }}>
                  <b>{product ? product.kodTowaru : ""}</b>
                </td>
                <td colSpan="5" className="adaptive-text">
                  <b>
                    {product && JSON.parse(product.nazwaMaterialu)
                      ? JSON.parse(product.nazwaMaterialu).nazwa
                      : ""}
                  </b>
                </td>
                <td>
                  <b>{product ? product.ilosc : ""}</b>
                </td>
                <td>
                  <b>{product ? "t" : ""}</b>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            );
          })}
          <tr style={{ width: "100%" }}>
            <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
              Wydał
            </td>
            <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
              Data
            </td>
            <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
              Odebrał
            </td>
          </tr>
          <tr style={{ height: "40px" }}>
            <td
              colSpan="4"
              rowSpan="2"
              className="adaptive-text wz-podglad-last2"
            >
              <b>{wzHeader.wydal}</b>
            </td>
            <td
              colSpan="4"
              rowSpan="2"
              className="adaptive-text wz-podglad-last2"
            >
              <b>
                {new Date(wzHeader.dataWystawienia).toLocaleDateString("PL-pl")}
              </b>
            </td>
            <td
              colSpan="4"
              rowSpan="2"
              className="adaptive-text wz-podglad-last2"
            ></td>
          </tr>
        </tbody>
      </table>
    );
  };

  const handleSave = () => {
    setVisible(false);
    // Pobieramy ponownie dokumenty WZ po zapisie zmian
    axios
      .get(`${baseURL}api/wz`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          dateFrom: formatDateParam(dateFrom),
          dateTo: formatDateParam(dateTo),
        },
      })
      .then((response) => {
        let docs = response.data;
        setDocuments(docs);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Błąd podczas pobierania dokumentów:", error);
        setLoading(false);
      });
  };

  const printSelectedDocs = () => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("Nie zaznaczono dokumentów do druku.");
      return;
    }

    printJS({
      printable: "printableContainer",
      type: "html",
      style: `
        @page { 
          size: A4 portrait; 
          margin: 5mm;
        }
        
        /* Container for each document (sets page-break) */
        .document-container {
          page-break-after: always;
        }
        
        /* Container for the 3 copies of a single WZ */
        .copies-container {
          display: flex;
          flex-direction: column;
          height: 287mm; /* A4 height (297mm) minus top/bottom margins */
          width: 200mm;  /* A4 width (210mm) minus left/right margins */
          justify-content: space-between;
        }
        
        /* Individual copy wrapper - exact 1/3 of A4 */
        .printable-wrapper {
          height: 90mm; /* Exactly 1/3 of available height (285mm/3) */
          margin: 0;
          box-sizing: border-box;
        }
        
        /* Table styling */
        .wz-podglad {
          font-family: arial, sans-serif;
          border-collapse: collapse;
          border: 1px solid #000;
          width: 100%;
          height: 100%;
          font-size: 10pt;
          table-layout: fixed;
        }
        
        .wz-podglad td {
          text-align: center;
          padding: 1px;
          height: 1.0em;
          overflow: hidden;
        }
        
        /* For cells that need to adapt font size if content is too large */
        .adaptive-text {
          position: relative;
        }
        
        .adaptive-text b, .adaptive-text p {
          display: inline-block;
          max-width: 100%;
          /*font-size: min(10pt, calc(60px / var(--ch-length, 10)));*/
        }
        
        .przeznaczenie-cell {
          word-break: break-word;
          white-space: normal !important;
          height: auto;
        }
        
        .wz-podglad-firma {
          padding: 4px;
          height: 8em;
          white-space: normal;
        }
        
        .wz-pozycja {
          height: 1.0em;
        }
        
        .wz-podglad-naglowki {
          border: 1px solid #000;
          text-align: center;
          background-color: #dddddd;
          font-size: 8.5pt;
          font-weight: normal;
        }

        p {
          margin: 0;
          padding: 0;
        }
        
        /* Apply auto-sizing font for all cells with content 
        .wz-podglad td:has(b), .wz-podglad td:has(p) {
          font-size: min(10pt, calc(80px / var(--ch-length, 10)));
        }*/
      `,
      scanStyles: false,
      targetStyles: ["*"],
    });
  };

  const printNewDesign = () => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("Nie zaznaczono dokumentów do druku.");
      return;
    }

    const printableNode = document.getElementById("printableContainerNewDesign");
    if (!printableNode) return;

    const styleLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .map(link => `<link rel="stylesheet" href="${link.href}">`)
      .join('\n');
    const styleTags = Array.from(document.querySelectorAll('style'))
      .map(style => style.outerHTML)
      .join('\n');

    const w = window.open('', '_blank');
    if (!w) return;
    w.document.write(`<!DOCTYPE html>
<html><head>
  <meta charset="utf-8">
  ${styleLinks}
  ${styleTags}
</head><body style="margin:0;padding:0;background:#fff;">
  ${printableNode.innerHTML}
</body></html>`);
    w.document.close();
    w.focus();

    // Czekamy na załadowanie wszystkich zewnętrznych arkuszy CSS przed drukiem
    const allLinks = Array.from(w.document.querySelectorAll('link[rel="stylesheet"]'));
    if (allLinks.length === 0) {
      w.print();
    } else {
      let pending = allLinks.length;
      const tryPrint = () => {
        pending--;
        if (pending <= 0) w.print();
      };
      allLinks.forEach((link) => {
        link.addEventListener('load', tryPrint);
        link.addEventListener('error', tryPrint); // błąd ładowania też nie blokuje druku
      });
    }
  };

  addLocale("pl", pl.pl);
  locale("pl");

  const renderHeader = () => {
    return (
      <div
        className="table-header"
        style={{
          display: "flex",
          padding: "0 10px 0 10px",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "0.5rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2 className="wz-list-title">{`Dokumenty ${docType}`}</h2>
          <SelectButton
            allowEmpty={false}
            value={docType}
            onChange={(e) => setDocType(e.value)}
            options={options}
            style={{ marginLeft: "30px" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "0.5rem",
            flexWrap: "wrap",
          }}
        >
          <label className="wz-toolbar-label">Od:</label>
          <Calendar
            value={dateFrom}
            onChange={(e) => setDateFrom(e.value)}
            dateFormat="dd.mm.yy"
            showIcon
            locale="pl"
            style={{ width: "150px" }}
            maxDate={dateTo}
          />
          <label className="wz-toolbar-label">Do:</label>
          <Calendar
            value={dateTo}
            onChange={(e) => setDateTo(e.value)}
            dateFormat="dd.mm.yy"
            showIcon
            locale="pl"
            style={{ width: "150px" }}
            minDate={dateFrom}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            label={`Drukuj`}
            icon="pi pi-print"
            className="button-print"
            onClick={printNewDesign}
            disabled={!selectedRows || selectedRows.length === 0}
          />
          <Button
            label={`Drukuj (stare)`}
            icon="pi pi-print"
            className="button-print p-button-secondary"
            onClick={printSelectedDocs}
            disabled={!selectedRows || selectedRows.length === 0}
          />
          <WZListModal
            /* onFilter={(value) => setGlobalFilter(value)} */ documents={
              documents
            }
            onFilter={onFilter}
          />
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
              value={globalFilter}
              onChange={onGlobalFilterChange}
              placeholder="Wyszukaj"
              className="search-field"
            />
          </IconField>
        </div>
      </div>
    );
  };

  const onFilter = (value) => {
    const filtersTemp = Object.keys(value).reduce((acc, key) => {
      acc[key] = { value: value[key], matchMode: FilterMatchMode.CONTAINS };

      return acc;
    }, {});

    setFilters((prev) => ({
      ...prev,
      ...filtersTemp,
    }));
  };

  useEffect(() => {
    console.log(filters);
    console.log(documents);
  }, [filters]);

  const tableHeader = renderHeader();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseURL}api/wz`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          dateFrom: formatDateParam(dateFrom),
          dateTo: formatDateParam(dateTo),
        },
      })
      .then((response) => {
        let docs = response.data;
        setDocuments(docs);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Błąd podczas pobierania dokumentów:", error);
        setLoading(false);
      });
  }, [user, token, dateFrom, dateTo]);

  useEffect(() => {
    axios
      .get(`${baseURL}api/firmy`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setFirmy(res.data))
      .catch(() => {});
  }, [token]);

  const getLogoForFirma = (firmaObj) => {
    if (!firmaObj || !firmy.length) return null;
    const found = firmy.find(
      (f) => (firmaObj.id && f.id === firmaObj.id) || (firmaObj.nip && f.nip === firmaObj.nip)
    );
    return found?.logo ?? null;
  };

  const dateBodyTemplate = (rowData) =>
    new Date(rowData.dataWystawienia).toLocaleDateString();
  const kontrahentBodyTemplate = (rowData) =>
    JSON.parse(rowData.odbiorca)?.nazwa || "-";
  const firmaBodyTemplate = (rowData) =>
    JSON.parse(rowData.firma)?.nazwa || "-";
  const egzBodyTemplate = (rowData) => JSON.parse(rowData.egz)?.adres || "-";
  const transportBodyTemplate = (rowData) =>
    JSON.parse(rowData.transport)?.nrRej || "-";
  const createdByBodyTemplate = (rowData) => rowData.wydal || "-";
  const oplaconoBodyTemplate = (rowData) => (
    <Checkbox
      checked={rowData.oplacono}
      disabled
      tooltip={`Kowota brutto: ${rowData.kwotaBrutto}, Kwota netto: ${rowData.kwotaNetto}`}
    />
  );
  const przewoznikBodyTemplate = (rowData) => 
    JSON.parse(rowData.przewoznik)?.nazwa || "-"
  
      // tooltip={`Kowota brutto: ${rowData.kwotaBrutto}, Kwota netto: ${rowData.kwotaNetto}`}
  ;
  const uwagiBodyTemplate = (rowData) => rowData.uwagi || "-";

  const rowExpansionTemplate = (data) => {
    return (
      <table className="tableExpansion">
        <tbody>
          <tr>
            <td>Firma</td>
            <td>{JSON.parse(data.firma)?.nazwa || "-"}</td>
          </tr>
          <tr>
            <td>Kopalnia</td>
            <td>{JSON.parse(data.egz)?.adres || "-"}</td>
          </tr>
          <tr>
            <td>Odbiorca</td>
            <td>{JSON.parse(data.odbiorca)?.nazwa || "-"}</td>
          </tr>
          <tr>
            <td>Transport</td>
            <td>{JSON.parse(data.transport)?.nrRej || "-"}</td>
          </tr>
          <tr>
            <td>Data wystawienia</td>
            <td>{new Date(data.dataWystawienia).toLocaleDateString()}</td>
          </tr>
          <tr>
            <td>Wydał</td>
            <td>{data.wydal || "-"}</td>
          </tr>
          <tr>
            <td>Opłacono</td>
            <td>
              <Checkbox
                checked={data.oplacono}
                disabled
                tooltip={`Kowota brutto: ${data.kwotaBrutto}, Kwota netto: ${data.kwotaNetto}`}
              />
            </td>
          </tr>
          <tr>
            <td>Przewoźnik</td>
            <td>
              <Checkbox
                checked={data.isPrzewoznik}
                disabled
              />
            </td>
          </tr>
          <tr>
            <td>Uwagi</td>
            <td>{data.uwagi || "-"}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div className="p-m-3 wz-list-page">
      <Toast ref={toast} />
      <ConfirmPopup />

      {loading ? (
        <ProgressBar
          mode="indeterminate"
          style={{ height: "5px", width: "100%" }}
        />
      ) : (
        <DataTable
          className="wz-list-table"
          value={documents.filter((e) => e.typDokumentu === docType)}
          paginator
          size="small"
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          rows={10}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="id"
          selection={selectedRows}
          removableSort
          globalFilter={globalFilter}
          onFilter={(e) => setFilters(e.filters)}
          filters={filters}
          emptyMessage="Brak dokumentów"
          globalFilterFields={[
            "typDokumentu",
            "numerWZ",
            "firma",
            "egz",
            "odbiorca",
            "transport",
            "dataWystawienia",
            "wydal",
            "uwagi",
          ]}
          header={tableHeader}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
          {isMobile ? (
            <Column expander={true} style={{ width: "2rem" }} />
          ) : null}
          <Column
            field="typDokumentu"
            header="Typ"
            body={(rowData) => (
              <Tag
                style={{ display: "flex", justifyContent: "center" }}
                value={rowData.typDokumentu}
                severity={rowData.typDokumentu === "WZ" ? "success" : "warning"}
                rounded
              ></Tag>
            )}
          ></Column>
          <Column
            filter={!isMobile}
            sortable
            field="numerWZ"
            header="Numer dokumentu"
          ></Column>
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Firma"
              field="firma"
              filterField="firma"
              showFilterMatchModes={false}
              filterElement={(options) => (
                <MultiSelect
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    ...new Map(
                      documents.map((doc) => {
                        const nazwa = JSON.parse(doc.firma)?.nazwa;
                        return [nazwa, { label: nazwa, value: nazwa }];
                      })
                    ).values(),
                  ].sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      firma: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                  placeholder="Wybierz firmę"
                />
              )}
              body={firmaBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Kopalnia"
              field="egz"
              filterField="egz"
              showFilterMatchModes={false}
              filterElement={(options) => (
                <MultiSelect
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    ...new Map(
                      documents.map((doc) => {
                        const nazwa = JSON.parse(doc.egz)?.adres;
                        return [nazwa, { label: nazwa, value: nazwa }];
                      })
                    ).values(),
                  ].sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      egz: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                  placeholder="Wybierz kopalnię"
                />
              )}
              body={egzBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Odbiorca"
              field="odbiorca"
              showFilterMatchModes={false}
              filterField="odbiorca"
              filterElement={(options) => (
                <MultiSelect
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    ...new Map(
                      documents.map((doc) => {
                        const nazwa = JSON.parse(doc.odbiorca)?.nazwa;
                        return [nazwa, { label: nazwa, value: nazwa }];
                      })
                    ).values(),
                  ].sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      odbiorca: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                  placeholder="Wybierz odbiorcę"
                />
              )}
              body={kontrahentBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Transport"
              field="transport"
              showFilterMatchModes={false}
              filterField="transport"
              filterElement={(options) => (
                <MultiSelect
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    ...new Map(
                      documents.map((doc) => {
                        const nrRej = JSON.parse(doc.transport)?.nrRej || "";
                        return [nrRej, { label: nrRej, value: nrRej }];
                      })
                    ).values(),
                  ].sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      transport: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                  placeholder="Wybierz transport"
                />
              )}
              body={transportBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Data wystawienia"
              field="dataWystawienia"
              showFilterMatchModes={false}
              filterField="dataWystawienia"
              body={dateBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Wydał"
              showFilterMatchModes={false}
              field="createdBy"
              filterField="wydal"
              filterElement={(options) => (
                <MultiSelect
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    ...new Map(
                      documents.map((doc) => {
                        const wydal = doc.wydal;
                        return [wydal, { label: wydal, value: wydal }];
                      })
                    ).values(),
                  ].sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      wydal: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                  placeholder="Wybierz osobę"
                />
              )}
              body={createdByBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Przewoźnik"
              field="przewoznik"
              showFilterMatchModes={false}
              filterField="przewoznik"
              filterElement={(options) => (
                <SelectButton
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    { label: "Tak", value: true },
                    { label: "Nie", value: false },
                  ]}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      isPrzewoznik: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                />
              )}
              body={przewoznikBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Opłacono"
              field="oplacono"
              showFilterMatchModes={false}
              filterField="oplacono"
              filterElement={(options) => (
                <SelectButton
                  // className="p-multiselect-modal"
                  value={options.value}
                  options={[
                    { label: "Tak", value: true },
                    { label: "Nie", value: false },
                  ]}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      oplacono: {
                        value: e.value,
                        matchMode: FilterMatchMode.CONTAINS,
                      },
                    })
                  }
                />
              )}
              body={oplaconoBodyTemplate}
            ></Column>
          ) : null}
          {!isMobile ? (
            <Column
              filter={!isMobile}
              sortable
              header="Uwagi"
              field="uwagi"
              filterField="uwagi"
              body={uwagiBodyTemplate}
            ></Column>
          ) : null}
          <Column
            header="Edycja"
            body={(rowData) =>
              user &&
              (user.role === "Administrator" ||
                rowData.createdBy === user.id) ? (
                <Button
                  icon="pi pi-pencil"
                  className="p-button-sm"
                  onClick={() => {
                    setSelectedWz(rowData);
                    setVisible(true);
                  }}
                />
              ) : (
                <></>
              )
            }
          />
          {user.role === "Administrator" && (
            <Column
              header="Usuń"
              body={(rowData) => (
                <Button
                  icon="pi pi-trash"
                  className="p-button-danger p-button-sm"
                  onClick={(e) => confirm1(e, rowData.id)}
                />
              )}
              headerStyle={{ textAlign: "center", width: "5rem" }}
              bodyStyle={{ textAlign: "center" }}
            />
          )}
        </DataTable>
      )}

      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        header="Edycja dokumentu WZ"
        maximized
      >
        <WZForm edit={true} data={selectedWz} handleSave={handleSave} />
      </Dialog>

      <div id="printableContainer" className="printable-hidden">
        {selectedRows.length > 0 &&
          selectedRows.map((doc, index) => (
            <div key={index} className="document-container">
              <div className="copies-container">
                {Array.from({ length: 3 }).map((_, idx) => (
                  <div key={idx}>
                    <div className="printable-wrapper">
                      {renderPrintableContent(doc)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>

      <div id="printableContainerNewDesign" className="printable-hidden">
        {selectedRows.length > 0 && selectedRows.map((doc, index) => {
          const parseJSON = (val) => {
            if (!val) return null;
            try { return typeof val === 'string' ? JSON.parse(val) : val; } catch { return null; }
          };
          const firmaObj = parseJSON(doc.firma);
          const logo = getLogoForFirma(firmaObj);
          const firmaWithLogo = firmaObj ? { ...firmaObj, logo } : null;
          const products = parseJSON(doc.products) ?? [];
          return (
            <div key={index} className="wz-print-page-break">
              <WZPrintTemplate
                data={{
                  numerWZ: doc.numerWZ,
                  typDokumentu: doc.typDokumentu,
                  egz: parseJSON(doc.egz),
                  firma: firmaWithLogo,
                  odbiorca: parseJSON(doc.odbiorca),
                  przeznaczenie: doc.przeznaczenie,
                  dataWystawienia: doc.dataWystawienia,
                  transport: parseJSON(doc.transport),
                  wydal: doc.wydal,
                  products,
                }}
                copyLabels={["ORYGINAŁ", "KOPIA", "KOPIA"]}
                className="wz-copies-print"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WZList;
